import { render, staticRenderFns } from "./VerifyDoc.vue?vue&type=template&id=20bc8472"
import script from "./VerifyDoc.vue?vue&type=script&lang=js"
export * from "./VerifyDoc.vue?vue&type=script&lang=js"
import style0 from "./VerifyDoc.vue?vue&type=style&index=0&id=20bc8472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports